import {
  OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES__VALUE
} from 'Constants'
import { Actions } from 'mailup-web-components'
import { modalActivateSimulateSimulateOpenCallback } from 'Pages/WorkflowsList/recoil/callbacks/modalActivateSimulate'
import {
  modalCopy,
  modalCopyWarning,
  modalDelete,
  modalSimulate
} from 'Pages/WorkflowsList/recoil/state/modals'
import { pageState } from 'Pages/WorkflowsList/recoil/state/page'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'

import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'

const ActionsMenu = ({ item, moreCountMessage }) => {
  const intl = useIntl()
  const history = useHistory()

  const setModalCopyState = useSetRecoilState(modalCopy)
  const setModalCopyWarningState = useSetRecoilState(modalCopyWarning)
  const setModalSimulate = useSetRecoilState(modalSimulate)
  const setModalDelete = useSetRecoilState(modalDelete)
  const { canCreateTrigger } = useRecoilValue(pageState)

  const simulateOpen = useRecoilCallback(
    modalActivateSimulateSimulateOpenCallback,
    []
  )

  const handleEdit = () => {
    history.push(`/automation/workflow/${item.Id}/edit`)
  }

  const handleCopy = () => {
    if (item.Type === OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES__VALUE) {
      setModalCopyWarningState((prev) => ({
        ...prev,
        show: true,
        idWorkflow: item.Id
      }))
    } else {
      setModalCopyState((prev) => ({
        ...prev,
        show: true,
        idWorkflow: item.Id
      }))
    }
  }

  const handleSimulate = () => {
    if (item.Type === OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE) {
      simulateOpen(item.Id)
    } else {
      setModalSimulate((prev) => ({
        ...prev,
        show: true,
        idWorkflow: item.Id,
        idSimulate: undefined,
        fetchData: false,
        currentIteration: 0,
        interval: 250,
        simulateStatus: undefined,
        simulateTotalCount: undefined,
        simulateDiscarded: undefined
      }))
    }
  }

  const handleStats = () => {
    history.push(`/automation/workflows/statistics/${item.Id}`)
  }

  const handleDelete = (value) => {
    setModalDelete((prev) => ({
      ...prev,
      show: true,
      idWorkflow: item.Id,
      name: item.Name
    }))
  }

  const menuActions = []

  menuActions.push({
    label: intl.formatMessage({ id: 'Load.MailupCommon.Edit' }),
    separator: false,
    onClick: handleEdit
  })

  canCreateTrigger &&
    item.Draft === false &&
    menuActions.push({
      label: intl.formatMessage({ id: 'Load.MailupCommon.Copy' }),
      separator: false,
      onClick: handleCopy
    })

  item.Draft === false &&
    menuActions.push({
      label: intl.formatMessage({ id: 'Load.MailupCommon.ActionSimulate' }),
      separator: false,
      onClick: handleSimulate
    })

  item.Draft === false &&
    (item.CountEmailMessages > 0 || item.CountSmsMessages > 0) &&
    menuActions.push({
      label: intl.formatMessage({ id: 'Load.MailupCommon.ActionStatistics' }),
      separator: false,
      onClick: handleStats
    })

  menuActions.push({
    label: intl.formatMessage({ id: 'Load.MailupCommon.Delete' }),
    separator: true,
    onClick: () => {
      handleDelete()
    }
  })

  return <Actions items={menuActions} />
}

ActionsMenu.propTypes = {
  item: PropTypes.object,
  moreCountMessage: PropTypes.number
}

export default ActionsMenu
